










import { Component, Vue, Emit, Prop } from 'vue-property-decorator';
import { CourseService } from '../../api/course';

@Component({})
export default class CourseList extends Vue {
  @Prop() private selectedId!: number;
  private courseService: CourseService = new CourseService();
  private data: any[] = [];
  private activeIndex = 0;
  private mounted() {
    this.courseService.GetByRights().then((response: any) => {
      this.data = response;
      if (this.data && this.data.length > 0) {
        if (this.selectedId === 0) {
          this.OnChange(this.data[0], 0);
        } else {
          let index: number = -1;
          for (const item of response) {
            index++;
            if (item.id === this.selectedId) {
              this.activeIndex = index;
              this.OnChange(item, index);
              break;
            }
          }
        }
      }
    });
  }

  @Emit('OnChange')
  private OnChange(item: any, index: number) {
    // item.selected = true;
    this.activeIndex = index;
    return item;
  }

}
